import { makeStyles } from 'tss-react/mui';

import {
  HEADER_HEIGHT_MD_LG_XL,
  HEADER_HEIGHT_XS_SM,
} from '@/styles/sunrunTheme.styles';

const useStyles = makeStyles({
  name: 'HeroFullOverlay',
})(({ brandColors, spacing, breakpoints, aspectRatio, typography }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    overflow: 'hidden',
  },
  immersive: {
    paddingTop: typography.pxToRem(HEADER_HEIGHT_XS_SM),
    [breakpoints.up('md')]: {
      paddingTop: typography.pxToRem(HEADER_HEIGHT_MD_LG_XL),
    },
  },
  tallDefault: {
    aspectRatio: aspectRatio['1/2'],
    [breakpoints.up('sm')]: {
      aspectRatio: aspectRatio['2/3'],
    },
    [breakpoints.up('md')]: {
      aspectRatio: aspectRatio['16/9'],
    },
  },
  minimal: {
    aspectRatio: aspectRatio['2/3'],
    [breakpoints.up('sm')]: {
      aspectRatio: aspectRatio['4/3'],
    },
    [breakpoints.up('md')]: {
      aspectRatio: aspectRatio['21/9'],
    },
  },
  horizontalAlignLeft: {
    justifyContent: 'flex-start',
  },
  horizontalAlignCenter: {
    justifyContent: 'center',
  },
  contentContainer: {
    height: '100%',
  },
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: spacing(4),
    paddingBottom: spacing(4),
  },
  centerText: {
    textAlign: 'center',
  },
  verticalAlignBottom: {
    justifyContent: 'flex-end',
  },
  verticalAlignCenter: {
    justifyContent: 'center',
  },
  verticalAlignTop: {
    justifyContent: 'flex-start',
  },
  absolute: {
    position: 'absolute',
  },
  backButton: {
    marginTop: spacing(2),
  },
  backButtonDark: {
    color: brandColors.white,
    '&:hover': {
      color: brandColors.offWhite,
    },
  },
  backButtonLight: {
    color: brandColors.primaryMain,
    '&:hover': {
      color: brandColors.mediumBlue,
    },
  },
  onDark: {
    backgroundColor: brandColors.black,
  },
  onLight: {
    backgroundColor: brandColors.tintsOffWhite40,
  },
}));

export default useStyles;
